export default "__VITE_ASSET__2a613f43__"